import BatchFeedDialog from './BatchFeedDialog.vue'

export default BatchFeedDialog